import React from "react";

import { House, PeopleAlt, Place } from "@mui/icons-material";
import { Stack } from "@mui/material";
import Grid from "@mui/material/Grid2";

import { StatBox } from "@/components/atoms";
import { AudienceSummary } from "@/types";
import { abbreviateNumber } from "@/utils";

interface AudienceSizeProps {
  data: AudienceSummary;
}

const AudienceSize: React.FC<AudienceSizeProps> = ({ data }) => {
  return (
    <>
      <Grid size={12}>
        <Stack direction="row" spacing={2}>
          {data.num_postcodes !== undefined && (
            <StatBox
              name="Postcodes"
              value={data.num_postcodes}
              valueFormatter={abbreviateNumber}
              icon={<Place fontSize="small" color="secondary" />}
            />
          )}
          {data.num_sectors !== undefined && (
            <StatBox
              name="Sectors"
              value={data.num_sectors}
              valueFormatter={abbreviateNumber}
              icon={<Place fontSize="small" color="secondary" />}
            />
          )}
          <StatBox
            name="Households"
            value={data.num_households}
            valueFormatter={abbreviateNumber}
            icon={<House fontSize="small" color="secondary" />}
          />
          <StatBox
            name="Audience Size"
            value={data.population_count}
            valueFormatter={abbreviateNumber}
            icon={<PeopleAlt fontSize="small" color="secondary" />}
          />
        </Stack>
      </Grid>
    </>
  );
};

export default AudienceSize;
